import { PromotionDto } from '../routes/promotions/store/Promotion';
import ApiHttpClient from './ApiHttpClient';

export default class Promotions {
  constructor(private readonly client: ApiHttpClient) {}

  async getAllPromotions(): Promise<PromotionDto[]> {
    return this.client.get('v1/provider/promotions');
  }

  async createPromotion(promotion: PromotionDto): Promise<PromotionDto> {
    return this.client.post('v1/provider/promotions', promotion);
  }

  async updatePromotion(promotion: PromotionDto): Promise<PromotionDto> {
    return this.client.put(`v1/provider/promotions/${promotion.id}`, promotion);
  }

  async deletePromotion(promotionId: string) {
    return this.client.delete(`v1/provider/promotions/${promotionId}`);
  }
}
